import React from 'react';
import {GROWL_TYPE} from "./const";

type Props = {
    id      : ID
    type    : GROWL_TYPE
    title   : string
    close   : callback
    fadeTime: number
}

// the url path of the created item's view
const URL_PATH: Record<GROWL_TYPE, string> = {
    [GROWL_TYPE.CLIENT]     : 'client',
    [GROWL_TYPE.ACCOUNT]    : 'crm/company',
    [GROWL_TYPE.CONTACT]    : 'crm/contact',
}

export default class ClientCreated extends React.Component<Props> {

    open = () => {
        gd.goTo('{0}/{1}'.f(URL_PATH[this.props.type], this.props.id))
        this.props.close();
    };

    copyLink = () => {

        const url = 'https://www.goodday.work/{0}/{1}'.f(URL_PATH[this.props.type], this.props.id);
        gd.utils.copyToClipboard(url);
        gd.growl.success("Link copied to clipboard");
        this.props.close();
    };

    render() {

        let label;
        switch (this.props.type) {
            case GROWL_TYPE.CLIENT   : label = 'Client created'; break;
            case GROWL_TYPE.ACCOUNT  : label = 'Company created'; break;
            case GROWL_TYPE.CONTACT  : label = 'Contact created'; break;
        }

        const classes = Classes("notification", "create")

        return (
            <div className={classes} style={{transition: "opacity " + this.props.fadeTime + "s"}}>
                <div className="flex-row-left-top">
                    <div className="left-indicator">
                        <div className="i5-done ui5-color-green fs-15 create-icon"/>
                    </div>
                    <div className="right-content">
                        <div className="ui5-txt-not-important-small m-b-8">{label}</div>
                        <div
                            className="ui5-txt-less-important-small txt-truncate max-w-225 m-b-8">{this.props.title}</div>
                        {this.props.id && (
                            <div className="flex-row-between-center">
                                <div className="flex-row-left-center">
                                    <div className="flex-row-left-center link m-r-20" onClick={this.open}>
                                        <div className="i5-open-new-window m-r-5"></div>
                                        <div className="ui5-txt-link-tiny">Open</div>
                                    </div>

                                    <div className="flex-row-left-center link" onClick={this.copyLink}>
                                        <div className="i5-link m-r-5"></div>
                                        <div className="ui5-txt-link-tiny">Copy link</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="close i5-delete" onClick={this.props.close}/>
            </div>
        )
    }
}
